import React from "react";
import axios from "axios";

class AddBrands extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pincode: '',
            name: '',
            area: '',
            description: '',
            images: [],
            email: '',
            password: '',
            city: '',
            productCategory: [],
            package: '',
            brandsnew: '',
            brandsNew:[],
            packageAmount: 0,
            submissionStatus: null,
            categories: [],
            packages: []
        };
    }

    componentDidMount() {
        this.fetchCategories();
        this.fetchPackages();
        this.fetchBrandsNew();
    }

    fetchCategories = async () => {
        try {
            const response = await axios.get("https://brand.aasmo.in/api/admin/getall-category");
            this.setState({ categories: response?.data?.categories || [] });
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    fetchPackages = async () => {
        try {
            const response = await axios.get("https://brand.aasmo.in/api/admin/package");
            this.setState({ packages: response?.data || [] });
        } catch (error) {
            console.error("Error fetching packages:", error);
        }
    };
    fetchBrandsNew = async () => {
        try {
            const response = await axios.get("https://brand.aasmo.in/api/admin/brandsnew");
            this.setState({ brandsNew: response?.data?.data || [] });
        } catch (error) {
            console.error("Error fetching packages:", error);
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handlePackageChange = (e) => {
        const selectedPackage = this.state.packages.find(pkg => pkg._id === e.target.value);
        const packageAmount = selectedPackage ? selectedPackage.price : 0;

        this.setState({
            package: e.target.value,
            packageAmount: packageAmount
        });
    };
    handleBrandsChange = (event) => {
        this.setState({ brandsnew: event.target.value });
    };
    handleCategoryChange = (e) => {
        // Get the selected options and map them to an array
        let selectedCategories = Array.from(e.target.selectedOptions, option => option.value);

        // Ensure productCategory is always an array
        if (selectedCategories.length === 1 && typeof selectedCategories[0] === 'string') {
            selectedCategories = [selectedCategories[0]];  // Wrap it in an array if only one item is selected
        }

        const categoryCount = selectedCategories.length;
        const basePackageAmount = this.state.packages.find(pkg => pkg._id === this.state.package)?.price || 0;

        console.log("Selected Categories:", selectedCategories); // Log the selected categories to check if it's an array

        this.setState({
            productCategory: selectedCategories, // Ensure it's always an array
            packageAmount: basePackageAmount * categoryCount
        });
    };



    handleFileChange = (e) => {
        this.setState({ images: Array.from(e.target.files) });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();

        formData.append('name', this.state.name);
        formData.append('area', this.state.area);
        formData.append('description', this.state.description);
        formData.append('email', this.state.email);
        formData.append('password', this.state.password);
        formData.append('city', this.state.city || "");
        formData.append('pincode', this.state.pincode || "");
        formData.append('package', this.state.package);
        formData.append('brandsNew', this.state.brandsnew);
        formData.append('packageAmount', this.state.packageAmount);

        this.state.productCategory.forEach(category => {
            formData.append('productCategory[]', category);
        });


        this.state.images.forEach(file => {
            formData.append('images', file);
        });

        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
            };

            const response = await axios.post("https://brand.aasmo.in/api/admin/brands", formData, config);

            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });

                setTimeout(() => {
                    window.location.href = "/list-brands"
                }, 2000);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    render() {
        const { submissionStatus, categories, packages, packageAmount,brandsNew } = this.state;

        return (
            <div className="col-md-12">
                <form onSubmit={this.handleSubmit}>
                    <div className="card">
                        <div className="header">
                            <h2>Add Store</h2>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>Name</label>
                                <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange} required />
                            </div>

                            <div className="form-group">
                                <label>Area</label>
                                <input type="text" className="form-control" name="area" value={this.state.area} onChange={this.handleChange} required />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea className="form-control" name="description" value={this.state.description} onChange={this.handleChange} required />
                            </div>

                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" className="form-control" name="email" value={this.state.email} onChange={this.handleChange} required />
                            </div>

                            <div className="form-group">
                                <label>Password</label>
                                <input type="password" className="form-control" name="password" value={this.state.password} onChange={this.handleChange} required />
                            </div>

                            <div className="form-group">
                                <label>City</label>
                                <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange} />
                            </div>
                            <div className="form-group">
                                <label>Pincode</label>
                                <input type="number" className="form-control" name="pincode" value={this.state.pincode} onChange={this.handleChange} required />
                            </div>
                            {/* Packages Dropdown */}
                            <div className="form-group">
                                <label>Package</label>
                                <select className="form-control" name="package" value={this.state.package} onChange={this.handlePackageChange} required>
                                    <option value="">Select Package</option>
                                    {packages.map(pkg => (
                                        <option key={pkg._id} value={pkg._id}>
                                            {pkg.title} - ₹{pkg.price}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Package Amount */}
                            <div className="form-group">
                                <label>Package Amount</label>
                                <input type="text" className="form-control" value={`₹${packageAmount}`} readOnly />
                            </div>

                            {/* Product Category Dropdown */}
                            <div className="form-group">
                                <label>Product Category</label>
                                <select className="form-control" name="productCategory" multiple value={this.state.productCategory} onChange={this.handleCategoryChange} required>
                                    {categories.map(category => (
                                        <option key={category._id} value={category._id}>
                                            {category.categoryName}
                                        </option>
                                    ))}
                                </select>
                                <small>Select multiple categories by holding Ctrl (Windows) or Command (Mac)</small>
                            </div>
                            <div className="form-group">
                                <label>Brands</label>
                                <select className="form-control" name="brandsnew" value={this.state.brandsnew} onChange={this.handleBrandsChange} required>
                                    <option value="">Select Brands</option>
                                    {brandsNew?.map(item => (
                                        <option key={item._id} value={item._id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Images</label>
                                <input type="file" className="form-control" name="images" multiple onChange={this.handleFileChange} required />
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success">Store added successfully!</div>
                            )}
                            {submissionStatus === 'error' && (
                                <div className="alert alert-danger">There was an error submitting the form.</div>
                            )}

                            <button className="btn btn-primary" type="submit">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default AddBrands;
